import Reflux from 'reflux';
import UserActions from "../actions/UserActions";


class UserStore extends Reflux.Store {
    constructor() {
        super();

        this.listenTo(UserActions.getUser, this._initialize);

        this._resetStore();
    }

    _resetStore() {
        this.user = undefined;
    }

    _initialize = () => {
        // Register this store to WUserInfo which is managing the way we're getting user
        document.WUserInfo.addListener("mywort.commons.user-store", this._getUserInfo);
    };

    _getUserInfo = (user) => {
        this.user = user;
        this.triggerData(user);
    };

    // Public Store Object, passed on trigger change
    getData() {
        return {
            user: this.user
        }
    }

    triggerData() {
        this.trigger(this.getData());
    }

}


export default new UserStore();



// WEBPACK FOOTER //
// ./js/mywort/commons/stores/UserStore.js